/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels } from "../../clients/individualPaymentParcelsController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
    params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/parcels",
        params: { financialPersonId: financialPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey(
      financialPersonId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels(
        financialPersonId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna as parcelas do plano (com valor ou com serial) com status da grid, multa, descontos, link de NFe autorizada, flags de integração bancária (Fealq/Vanzolini/Fusp/PecegePay) e indicadores de boleto gerado e recorrência de cartão. Ordenadas por tipo e número da parcela. Migrado do legado IndividualPayment/LoadGridDataAsyncParcels. **(Requer Authorization para autenticação)**
 * @summary Retorna as parcelas do plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryKey(
      financialPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryOptions(
        financialPersonId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
